export default function Contact() {
  return (
    <section id="contact" className="relative py-20 md:py-32 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="relative overflow-hidden rounded-lg bg-foreground-950 text-background-50 px-6 md:px-16 py-14 md:py-24">
          <div className="absolute inset-0 dotted-bg opacity-30"></div>
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary-500/25 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-accent-500/20 rounded-full blur-3xl"></div>

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-400 font-semibold mb-4">
                <span className="w-8 h-px bg-primary-500"></span>
                Let's talk
              </div>
              <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
                Have a hard problem? <br className="hidden md:block" />
                <span className="text-primary-400">Let's go.</span>
              </h2>
              <p className="mt-5 md:mt-6 text-base md:text-lg text-background-100/80 leading-relaxed max-w-xl">
                Whether it's a new build, a modernization, a security overhaul or an
                advisory engagement — I'm happy to jump on a call and figure out if it's
                a fit.
              </p>

              <div className="mt-8 md:mt-10">
                <a
                  href="tel:+18888663428"
                  className="flex items-center gap-4 rounded-lg bg-foreground-900/60 hover:bg-foreground-900 border border-foreground-800 hover:border-primary-500 px-5 py-4 transition-colors cursor-pointer"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-xs text-background-100/60 uppercase tracking-widest">
                      Toll Free
                    </div>
                    <div className="font-heading text-base md:text-lg font-semibold">
                      888-866-3428
                    </div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-xl text-background-100/60"></i>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-lg bg-background-50/5 border border-background-50/15 backdrop-blur p-6 md:p-8">
                <div className="text-xs uppercase tracking-widest text-background-100/60 mb-4">
                  Currently
                </div>
                <ul className="space-y-4">
                  {[
                    { i: "ri-focus-3-line", t: "Advisory engagements & fractional CTO work" },
                    { i: "ri-rocket-line", t: "Building AI + security ventures under my brands" },
                    { i: "ri-user-star-line", t: "Mentoring the next generation via Techy Bootcamp" },
                    { i: "ri-leaf-line", t: "Supporting cleaner coastlines with Clear Beaches" },
                  ].map((row) => (
                    <li key={row.t} className="flex items-start gap-3">
                      <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500/20 text-primary-400 flex-shrink-0 mt-0.5">
                        <i className={`${row.i} text-lg`}></i>
                      </span>
                      <span className="text-sm md:text-base text-background-100/90 leading-relaxed">
                        {row.t}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}